import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        margin: theme.spacing(1, -1.5),
      },
      selectIcon: {
        color: sicrediColor.primarySicredi,
        fontSize: 16,
        marginLeft: -24,
        '.Mui-disabled &': {
          color: sicrediColor.secondarySicrediLight,
        },
      },
    }),
  { name: 'RelatorioFiltros' }
);
